import { render, staticRenderFns } from "./parentalcontrol.vue?vue&type=template&id=c830a188&scoped=true&"
import script from "./parentalcontrol.vue?vue&type=script&lang=js&"
export * from "./parentalcontrol.vue?vue&type=script&lang=js&"
import style0 from "./parentalcontrol.vue?vue&type=style&index=0&id=c830a188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.5@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c830a188",
  null
  
)

export default component.exports